/*
 * @Description: 委派规则 api
 * @Author: lidan
 * @Date: 2020-08-18 10:06:26
 * @LastEditors: 樊文静
 * @LastEditTime: 2021-08-16 19:59:45
 */
import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_E6YUN_BASE_WEB,
  E6_MS_TMS_BASE_WEB = "",
  E6_MS_TMS_BUSI_WEB = ""
} = e6ModuleOrderWaybillProcessApi;

//********************* 委派规则管理 ****************** */

//  获取委派规则管理列表数据
export function findDelegateRuleByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/delegateRule/findByPage`,
    method: "post",
    data
  });
}
//新增委派规则信息
export function saveDelegateRule(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/delegateRule/save`,
    method: "post",
    data
  });
}

//修改委派规则信息
export function updateDelegateRule(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/delegateRule/updateById`,
    method: "post",
    data
  });
}

//修改委派规则状态
export function updateState(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/delegateRule/updateState`,
    method: "post",
    data
  });
}

//查询委派规则详细信息
export function getInfoDelegateRule(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/delegateRule/queryById`,
    method: "get",
    params
  });
}

//删除委派规则信息
export function deleteDelegateRules(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/delegateRule/batchDelete`,
    method: "post",
    data
  });
}

//导出委派规则信息
export function exportDelegateRuleInfo(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_BASE_WEB}/delegateRule/exportDelegateRuleInfo`,
    method: "post",
    data
  });
}

//(下拉框)查询全部的承运商信息
export function findAllCarrierByPageDelegateRules(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/findAllCarrierByPage`,
    method: "post",
    data
  });
}
//获取消息提醒设置中的用户
export function getListByUserType() {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/user/getListByUserType?userType=2`,
    method: "get"
  });
}

//线路代码唯一性校验
export function existDelegateRuleCode(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/delegateRule/existDelegateRuleCode`,
    method: "get",
    params
  });
}

//(罗牛山)委派规则修改
//获取委派规则列表
export function fetchDelegateList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/delegate/rule/query`,
    method: "post",
    data
  });
}
//获取详情
export function fetchDelegateDetail(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/delegate/rule/detail`,
    method: "get",
    params
  });
}
//保存新增修改
export function saveDelegateEdit(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/delegate/rule/save`,
    method: "post",
    data
  });
}
//删除委派规则
export function deleteDeledate(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/delegate/rule/delete`,
    method: "post",
    data
  });
}
// 查看比较运算接口
export function getFeeRuleOperateList() {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/delegate/listOperator`,
    method: "get"
  });
}
//获取条件设置条件下拉
export function getConditionList(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/delegate/listConditionDefine`,
    method: "get",
    params
  });
}
//校验方案名称唯一性接口
export function validDelegateNameUnique(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/delegate/rule/unique`,
    method: "post",
    data
  });
}
//获取委派方案名称下拉接口（订单、运单列表页委派弹框使用）
export function fetchDelegateNameList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/delegate/rule/find`,
    method: "post",
    data
  });
}
//获取委派规则历史记录列表数据
export function fetchDelegateUpdateRecordData(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/delegate/rule/history`,
    method: "post",
    data
  });
}
